import {
  Input,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from '@planuze/ui';
import { usePlansContent } from '../../../content/sections/plans.js';
import type { PlanForm } from '../../../hooks/use-plan-form.js';
import { UserPicker } from '../../users/user-picker.js';
import { OrgPicker } from '../org-picker.js';
import { InheritanceFields } from './inheritance-fields.js';

/* Direcionamento do plano negociado (ADR-0435): tipo de alvo (org XOR usuário) + picker + janela
   de validade + motivo auditado + herança de acesso a packages/templates (ADR-0595). Só faz
   sentido na criação de negociado; renderiza os campos, o call-site embrulha em Card. */
export function TargetingFields({ form }: { readonly form: PlanForm }) {
  const copy = usePlansContent();
  return (
    <div className="space-y-4">
      <div className="space-y-3 rounded-md border border-border p-3">
        <Label className="text-sm font-medium">{copy.formFields.targeting}</Label>
        <div className="space-y-1.5">
          <Label htmlFor="pf-target-type">{copy.formFields.targetType}</Label>
          <Select
            value={form.targetType}
            onValueChange={(v) => form.setTargetType(v as 'organization' | 'user')}
          >
            <SelectTrigger id="pf-target-type" aria-label={copy.formFields.targetType}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="organization">{copy.formFields.organization}</SelectItem>
              <SelectItem value="user">{copy.formFields.user}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>{copy.formFields.target}</Label>
          {form.targetType === 'organization' ? (
            <OrgPicker value={form.org} onChange={form.setOrg} />
          ) : (
            <UserPicker value={form.user} onChange={form.setUser} />
          )}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <Label htmlFor="pf-from">{copy.formFields.validFrom}</Label>
            <Input
              id="pf-from"
              type="date"
              value={form.validFrom}
              onChange={(e) => form.setValidFrom(e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="pf-until">{copy.formFields.validUntil}</Label>
            <Input
              id="pf-until"
              type="date"
              value={form.validUntil}
              onChange={(e) => form.setValidUntil(e.target.value)}
            />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="pf-reason">{copy.formFields.reason}</Label>
          <Textarea
            id="pf-reason"
            rows={3}
            maxLength={500}
            value={form.reason}
            onChange={(e) => form.setReason(e.target.value)}
          />
        </div>
      </div>
      <InheritanceFields form={form} />
    </div>
  );
}
